export default "__VITE_ASSET__Di75Wxam__"